module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight-976ccf39219f7cb3d1809f902e6970b7.png";